import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AmazePlayerModule } from 'amaze-player';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AmazePlayerModule, RouterModule.forRoot([])],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
